import { Button } from "ui/components/Button/Button";
import { transformRoute, useTranslate } from "helpers";
import { ContactEmailHeaderProps } from "./types";
import { ButtonLink } from "ui/components/Button/ButtonLink";
import { Routes as ContactRoutes } from "ui/modules/contacts/navigation";

const ContactEmailHeader = ({
    contactDetail,
    onAdd,
}: ContactEmailHeaderProps) => {
    const { t } = useTranslate();

    if (!contactDetail.id) return <></>;

    return (
        <div className="flex gap-2">
            <ButtonLink
                size="small"
                variant="warning"
                children="Pregled"
                to={transformRoute(
                    ContactRoutes.ContactEmailSearchPageRouter,
                    {
                        id: contactDetail.id,
                    }
                )}
                startIcon="/media/icons/search.svg"
            />
            <Button
                size="small"
                variant="secondary"
                children={t("admin.contact.email.add")}
                onClick={onAdd}
                startIcon="/media/icons/plus.svg"
            />
        </div>
    );
};

export default ContactEmailHeader;
